import { createSelector } from 'reselect'

// import { getCookie } from '@utils/cookies';
import { ACCESS_TOKEN } from 'api/client'
import { getCookie } from 'utils/cookies'
import { Redux } from 'types/local'
import { State } from './header.reducer'

const getState = (state: Redux.State): State => state.app.header

const isLoading = createSelector(getState, (state) => state.isLoading)
const isConnected = createSelector(getState, (state) => state.isConnected)
const chains = createSelector(getState, (state) => state.chains)
const selectedAddress = createSelector(getState, (state) => state.selectedAddress)
const selectedChainId = createSelector(getState, (state) => state.selectedChainId)
const tokenInfo = createSelector(getState, (state) => state.tokenInfo)
const isAuthenticated = createSelector(getState, (state) => {
  return getCookie(ACCESS_TOKEN) !== '' && getCookie(ACCESS_TOKEN) !== null && getCookie(ACCESS_TOKEN) !== undefined
})

const auditProvider = createSelector(getState, (state) => state.auditProvider)

const getAuthHeaders = createSelector(getState, (state) => ({
  Authorization: ['Bearer', getCookie(ACCESS_TOKEN)].filter(Boolean).join(' '),
}))
export const headerSelectors = {
  isLoading,
  isAuthenticated,
  chains,
  selectedChainId,
  tokenInfo,
  isConnected,
  getAuthHeaders,
  auditProvider,
  selectedAddress,
}
